var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a92d026b04441a09efcc3145e1f6cea7dbc12920"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fleatoweb@fleato"]={id:"a92d026b04441a09efcc3145e1f6cea7dbc12920"};
      